// 首页
const index = () => import('@/views/index/index.vue')
const order = () => import('@/views/index/order.vue')
const address = () => import('@/views/index/address.vue')
const shop = () => import('@/views/index/shop.vue')
const route = [
    {
        path: '/',
        component: index,
        redirect: '/index',
    },

    // 首页
    {
        path: '/index',
        name: 'index',
        component: index, 
    },
	// 订单
	{
	    path: '/order',
	    name: 'order',
	    component: order, 
	},
	// 地址
	{
	    path: '/address',
	    name: 'address',
	    component: address, 
	},
	// 主页
	{
	    path: '/shop',
	    name: 'shop',
	    component: shop, 
	},
]
export default route
